import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';
import { aktivitet } from './Aktivitet/AktivitetVy';
import { aktivitetDok } from './AktivitetDok/AktivitetDokVy';
import { bokningAktivitet } from './Bokning/BokningVy';
import { statistik } from './Statistikrapportering/StatistikrapporteringVy';

export const BOVyer = initConst<IComponentsConfig>(() => ({
  BOAktivitet: [aktivitet, statistik],
  BOAktivitetDok: [aktivitetDok],
  BOBokning: [bokningAktivitet],
}));
